import Rest from '@/services/Rest';

/**
 * @typedef {DuplicateService}
 */
export default class DuplicateService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/product/duplicate'
}